import { Button } from '@karma/components';
import { useTranslation } from 'react-i18next';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import useAction from 'hooks/useAction';
import { useCardRetailerSquareBreakpoint } from 'hooks/grid/useCardRetailerSquareBreakpoint';
import { pushBackStoreInfoModal } from 'store/modals/actions';
import GoToStoreButton from 'components/atoms/GoToStoreButton/GoToStoreButton';
import { Wrapper, Name, HoverContainer, CardContent, StyledStoreLogo } from './CardRetailerSquare.style';

const CardRetailerSquare = ({ retailer }) => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const showStoreInfoModal = useAction(pushBackStoreInfoModal);
  const breakpoint = useCardRetailerSquareBreakpoint();
  const { direction, logoSize, fontValiant, spacing } = breakpoint?.content || {};

  const isNameMultipleWords = retailer.name.trim().split(/\s+/).length > 1;

  return (
    <Wrapper $height={breakpoint?.itemAbsoluteHeight}>
      <CardContent direction={direction} spacing={spacing} fullWidth>
        <StyledStoreLogo src={retailer.logo_image_uri} alt={retailer.name} size={logoSize} direction={direction} />
        <Name variant={fontValiant} isNameMultipleWords={isNameMultipleWords} direction={direction}>
          {retailer.name}
        </Name>
      </CardContent>

      <HoverContainer direction="column" spacing={6} fullWidth>
        <GoToStoreButton
          retailer={retailer}
          buttonProps={{
            size: 'verySmall',
            type: 'primary',
          }}
        />

        <Button
          onClick={() => showStoreInfoModal({ retailer })}
          size="verySmall"
          type="outline"
          {...contextDataAttrs}
          data-alooma-element={ALOOMA.ELEMENTS.VIEW_STORE_INFO}
          data-alooma-retailer-id={retailer.self_id}
        >
          {t('app:storeInfo')}
        </Button>
      </HoverContainer>
    </Wrapper>
  );
};

export default CardRetailerSquare;
